import api from '../api'

export interface Customer {
  id: number
  name: string
  email?: string
  phone?: string
  notes?: string
  created_by_id: number
  created_at: string
  updated_at: string
  creator?: {
    id: number
    email: string
  }
  shared_with_users?: Array<{
    id: number
    email: string
  }>
}

export interface CustomerFormData {
  name: string
  email?: string
  phone?: string
  notes?: string
}

export const customersApi = {
  // Get all customers
  getAll: async (params?: { q?: string }) => {
    const response = await api.get<{ customers: Customer[] }>('/customers', { params })
    return response.data
  },

  // Get single customer
  getOne: async (id: number) => {
    const response = await api.get<{ customer: Customer }>(`/customers/${id}`)
    return response.data
  },

  // Create customer
  create: async (data: CustomerFormData) => {
    const response = await api.post<{ customer: Customer; message: string }>('/customers', { customer: data })
    return response.data
  },

  // Update customer
  update: async (id: number, data: CustomerFormData) => {
    const response = await api.put<{ customer: Customer; message: string }>(`/customers/${id}`, { customer: data })
    return response.data
  },

  // Delete customer
  delete: async (id: number) => {
    await api.delete(`/customers/${id}`)
  },

  // Share customer with another user
  share: async (id: number, userId: number) => {
    const response = await api.post<{ customer: Customer; message: string }>(`/customers/${id}/share`, { user_id: userId })
    return response.data
  },

  // Unshare customer
  unshare: async (id: number, userId: number) => {
    const response = await api.delete<{ customer: Customer; message: string }>(`/customers/${id}/unshare`, { 
      data: { user_id: userId } 
    })
    return response.data
  }
}
